import { render, staticRenderFns } from "./BinderTemplateList.vue?vue&type=template&id=618c62fa&"
import script from "./BinderTemplateList.vue?vue&type=script&lang=js&"
export * from "./BinderTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports